export class Article {
    Id: number;
    PicName: string;
    SmallPic: string;
    Subject: string;
    Description: string;
    MetaDescription: string;
    Content: string;
    Updated: string;
    Created: string;
    Active: boolean;
  
  }
  export class ArticleTag {
    Id: number;
    ArticleId: number;
    Tag: string;
    Updated: string;
    Created: string;
    Active: boolean;
  
  }
  export class ArticleView {
    Article: Article;
    Tags: Array<ArticleTag>;
  
  }
  export class ListOfArticleViewPartial {
    ArticleList: Array<ArticleView>;
    TotalCount: number;
    IdList: Array<number>;
  }